import { BuildInfo } from './build-info.model';

export class AppBuildInfo {
    appBuildInfo: { "changeSet": string; "buildNumber": string; "buildJob": string; "buildAgent": string; "buildTime": string; };
    public apiBuildInfo: any;
    public webBuildInfo: any;
}
